import React from "react";
import { OptionDropdown } from "@/components/ui/OptionDropdown";
import type { DropdownOption } from "@/components/ui/OptionDropdown";
import { BriefStatus } from "../types";
import { BRIEF_STATUS_CONFIG } from "../briefStatusConfig";

interface BriefStatusBadgeProps {
  status: BriefStatus;
  onStatusChange?: (status: BriefStatus) => void;
  disabled?: boolean;
  align?: "left" | "right";
}

const OPTIONS: DropdownOption<BriefStatus>[] = Object.entries(
  BRIEF_STATUS_CONFIG
).map(([value, cfg]) => ({
  value: value as BriefStatus,
  label: cfg.label,
  bg: cfg.bg,
  text: cfg.text,
  dot: cfg.dot,
}));

export const BriefStatusBadge: React.FC<BriefStatusBadgeProps> = ({
  status,
  onStatusChange,
  disabled = false,
  align = "left",
}) => {
  return (
    <OptionDropdown
      value={status}
      options={OPTIONS}
      onChange={onStatusChange}
      disabled={disabled}
      align={align}
    />
  );
};
